import { OT_APP_COOKIE } from "src/utils/constants";
import { isNativeApp } from "src/utils/isNativeApp";

function isAppWebview(): boolean {
  if (isNativeApp) {
    return true;
  }

  if (typeof window === "undefined") {
    return false;
  }

  const params = new URLSearchParams(window.location.search);

  if (params.has("app")) {
    return true;
  }

  if (window.location.pathname.startsWith("/app/")) {
    return true;
  }

  return document.cookie
    .split("; ")
    .some((cookie) => cookie.startsWith(`${OT_APP_COOKIE}=`));
}

export { isAppWebview };
